import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { saveTokensToLocalStorage } from "../../Utility/AccessAndRefreshTokenStorage";

const URL = `${process.env.REACT_APP_BACKEND_HOSTED_ON}${process.env.REACT_APP_SUBMIT_LOG_IN_FORM}`;

export const generateLoginRequest = createAsyncThunk(
  "generate/login/request",
  async (loginData, thunkApi) => {
    try {
      const request = await axios.post(URL, loginData);
      const response = request.data;
      return response;
    } catch (error) {
      //* You can handle error cases and return custom error messages or perform additional actions here
      return thunkApi.rejectWithValue(error?.response?.data);
    }
  }
);

export const generateLoginRequestSlice = createSlice({
  name: "requestServerForLogin",
  initialState: {
    formSubmitted: false,
    response: null,
    loading: false,
    success: false,
    error: null,
    accessToken: null,
    refreshToken: null,
  },
  reducers: {
    setDefaultLoginInitialState: (state) => {
      state.formSubmitted = false;
      state.response = null;
      state.loading = false;
      state.success = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(generateLoginRequest.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(generateLoginRequest.fulfilled, (state, action) => {
        state.success = action.payload?.success;
        state.response = action.payload;
        state.loading = false;
        state.error = null;

        // * Set token in local storage
        const accessToken = state?.response?.msg?.accessToken;
        const refreshToken = state?.response?.msg?.refreshToken;
        state.accessToken = accessToken;
        state.refreshToken = refreshToken;
        saveTokensToLocalStorage(accessToken, refreshToken, true);
      })
      .addCase(generateLoginRequest.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
        state.response = null;
        state.success = action.payload?.success;
      });
  },
});

export const { setDefaultLoginInitialState } =
  generateLoginRequestSlice.actions;

export default generateLoginRequestSlice.reducer;

// async function test() {
//   await axiosInterceptors()
//     .then((res) => {
//       console.log(res);
//     })
//     .catch((error) => {
//       console.log(error);
//     });
// }
// test();
